var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CloudConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { Column } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { squel } from '@symon-ai/wisepipe-squel';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationState } from './validation/toolValidationResult';
const schema = {
    $id: 'urn:wisepipe-common-pipe:CloudConfig',
    type: 'object',
    properties: {}
};
let CloudConfig = CloudConfig_1 = class CloudConfig extends ToolConfig {
    constructor(customFormats) {
        super(ToolType.CLOUD, customFormats);
        JSON.validate(this, CloudConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return CloudConfig_1.outs[0];
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return CloudConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return CloudConfig_1.outs;
    }
    static get ins() {
        return [];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.CLOUD.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.UNSEEN], this.ins, this.outs, ['cars'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        // https://www.kaggle.com/orgesleka/used-cars-database/data
        const columns = [
            new Column('dateCrawled', 'date'),
            new Column('name', 'string'),
            new Column('seller', 'string'),
            new Column('offerType', 'string'),
            new Column('price', 'number'),
            new Column('abtest', 'string'),
            new Column('vehicleType', 'string'),
            new Column('yearOfRegistration', 'number'),
            new Column('gearbox', 'string'),
            new Column('powerPS', 'number'),
            new Column('model', 'string'),
            new Column('kilometer', 'number'),
            new Column('monthOfRegistration', 'number'),
            new Column('fuelType', 'string'),
            new Column('brand', 'string'),
            new Column('notRepairedDamage', 'string'),
            new Column('dateCreated', 'date'),
            new Column('nrOfPictures', 'number'),
            new Column('postalCode', 'number'),
            new Column('lastSeen', 'date')
        ];
        const exp = tsb.export(this.outs[0]);
        for (const col of columns) {
            exp.makeNew(col, undefined, true);
        }
        const sample = squel.select().from('cars');
        // alias to correct names and capitalization
        for (const column of columns) {
            sample.field(escape(column.name), column.name);
        }
        tsb.setSample(this.outs[0], sample);
        exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        return tsb.build();
    }
    // eslint-disable-next-line class-methods-use-this
    isValidForCalc(iConfigHelper, ins) {
        return ToolValidationState.VALID;
    }
};
CloudConfig = CloudConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolType.CLOUD)
], CloudConfig);
export { CloudConfig };
//# sourceMappingURL=cloudConfig.js.map